// extracted by mini-css-extract-plugin
export var activeDot = "_2v-c";
export var buttonContainer = "_2v-9";
export var channelButton = "_2v-a";
export var clickable = "_2v-d";
export var content = "_2v-0";
export var contentFull = "_2v-2";
export var contentThird = "_2v-1";
export var contentWrapper = "_2v-7";
export var description = "_2v-5";
export var heightShort = "_2v-f";
export var image = "_2v-3";
export var imageContainer = "_2v-4";
export var selectButton = "_2v-e";
export var spinnerContainer = "_2v-b";
export var titleContent = "_2v-8";
export var titleWrapper = "_2v-6";